export const BIN_NUMBER_LENGTH = 8 as const;
